

























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import LogTable from "../../../components/LogTable/index.vue";
import { dateFormat, trim } from "../../../util";
import FileList from "../../../components/FileList/index.vue";
import UserSelect from "../../../components/UserSelect/index.vue";
import { ElForm } from "element-ui/types/form";
import UploadFile from "../../../../pt/components/UploadFile/index.vue";
import UrgerSelect from "../../../../pt/components/UrgerSelect/index.vue";

@Component({
  name: "WbenSendProcessMobile",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    LogTable,
    FileList,
    UserSelect,
    UrgerSelect
  }
})
export default class WbenSendProcessMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessId: any = null;
  private processData: any = null;
  private flowData: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private prefix: string = "";
  private fileData: any = [];
  private transmitModalShow: boolean = false;
  private transmitForm: any = {
    userName: "",
    userId: "",
    idea: ""
  };
  private rulesTransmit: any = {
    userName: [{ required: true, message: "转发人接收人不能为空" }]
  };
  private transmitUserBox: any = {
    show: false
  };
  private transmitUsers: any = [];
  private iframeUrl: string = "";
  private iframeHeight: string = "0px";
  private urgersShow: boolean = false; // 催办人弹窗

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.businessId = this.processData.businessId;
      this.getFlowData();
    }
  }

  /*已发的流程事项数据查询*/
  async getFlowData() {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web"
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getSendDetail(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取已发的流程事项数据失败:" + message);
        return false;
      }
      this.title = data.businessName;
      this.userName = data.run.createUserName;
      this.timeText = data.run.createTime ? dateFormat(data.run.createTime) : "--";
      this.flowData = data;
      this.fileData = data.atts;
      if (this.flowData.packageType === 3) {
        const iframeConfig: any = JSON.parse(this.flowData.fields.iframe.value);
        const path = iframeConfig.web;
        const searchParams = new URLSearchParams({
          businessId: this.processData.businessId,
          clientType: "web",
          page: "sent"
        });
        if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
          this.iframeUrl = `${path}?${searchParams}`;
        } else {
          this.iframeUrl = `${window.origin}${path}?${searchParams}`;
        }
        this.iframeHeight = iframeConfig.padHeight + "px";
      }
    } catch (error: any) {
      this.$message.error("获取已发的流程事项数据失败:" + error);
    }
  }

  /*表单点击操作按钮之后关闭弹窗*/
  childEvt(data: any) {
    if (data.type === "close") {
      this.$emit("childEvt", { type: "close" });
    } else if (data.type === "refresh") {
      this.getFlowData();
    }
  }

  /*转发接收人弹窗*/
  showTransmitUserBox() {
    this.transmitUserBox.show = true;
  }

  /*转发接收人选择*/
  transmitUserChecked(data: any) {
    if (data.source.length === 0) {
      this.transmitUsers = [];
      this.transmitForm.userName = "";
      this.transmitForm.userId = "";
      return;
    }
    this.transmitForm.userName = data.text;
    this.transmitForm.userId = data.valueText;
    this.transmitUsers = this.transmitForm.userId.split(",");
  }

  /*转发弹窗*/
  transmitEvt() {
    this.transmitModalShow = true;
  }

  /*转发提交*/
  async transmit() {
    let flag;
    await (this.$refs.wbenTransmitForm as ElForm).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      let ccs: any = [];
      if (this.transmitForm.userName !== "") {
        //转发人
        let ccUserIds = this.transmitForm.userId.split(","),
          ccUserNames = this.transmitForm.userName.split(",");
        for (let i = 0; i < ccUserIds.length; i++) {
          ccs.push({
            realName: ccUserNames[i],
            userId: ccUserIds[i]
          });
        }
      }
      try {
        const { success, message } = await request({
          url: this.prefix + Api.transmitProcess(),
          method: "post",
          data: {
            businessName: this.flowData.businessName,
            businessId: this.flowData.businessId,
            ccs: ccs.length > 0 ? ccs : null,
            idea: trim(this.transmitForm.idea),
            proTaskId: this.flowData.task.procTaskId,
            procTaskName: this.flowData.task.procTaskName,
            utKey: this.flowData.task.utKey
          }
        });
        if (!success) {
          this.$message.error(`转发失败:${message}`);
          return false;
        }
        this.transmitModalShow = false;
        this.$message.success(`转发成功`);
        this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
      } catch (error: any) {
        this.$message.error(`转发失败:${error}`);
      }
    }
  }

  /* 催办先选人 */
  async urgeEvt() {
    this.urgersShow = true;
  }

  /* 催办 */
  async handleUrgeEvt(data: any) {
    try {
      const urgerIds: any = [...data.childMatterUrgers, ...data.curMatterUrgers];
      const { success, message } = await request({
        url: this.prefix + Api.urgeProcess(this.processData.businessId),
        method: "put",
        data: {
          urgerIds
        }
      });
      if (!success) {
        this.$message.error(`催办失败:${message}`);
        return false;
      }
      this.$message.success(`催办成功`);
      this.urgersShow = false;
    } catch (error) {
      this.$message.error(`催办失败:${error}`);
    }
  }
}
